module.exports = __webpack_public_path__ + "static/media/ux-fundomate-persona-steve@2x.a445aead.png";